import { useState } from 'react';
import { useLazyQuery } from '@apollo/client/react';
import { Button } from '@repo/ui/Button';
import type { Mercury } from '@repo/types/Models';
import MessageBodyModal from './MessageBodyModal';
import GET_SMS_REQUEST_Q from '../gql/smsRequest_show.gql';

export interface MessageBodyCellLazyProps {
  id: string;
}

const MessageBodyCellLazy = ({ id }: MessageBodyCellLazyProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [fetchSms, { data, loading }] = useLazyQuery(GET_SMS_REQUEST_Q, {
    variables: { id },
  });

  const handleClick = async () => {
    if (!data) {
      await fetchSms({ variables: { id } });
    }
    setIsOpen(true);
  };

  return (
    <>
      <Button
        size="sm"
        variant="secondary"
        icon="visibility"
        onClick={handleClick}
        disabled={loading}
      >
        View body
      </Button>
      {data?.smsRequest && (
        <MessageBodyModal
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          sms={data.smsRequest as unknown as Mercury.Models.SMS}
        />
      )}
    </>
  );
};

export default MessageBodyCellLazy;
